module.exports = __webpack_public_path__ + "7e4b29ba/img/product-icon-grey.b248963c.svg";